import { dataCheckDesktopSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCheckDesktopSolid = /*#__PURE__*/createIcon(dataCheckDesktopSolid)
export default IconCheckDesktopSolid
